'use client';

export default function VideoDemo() {
  return (
    <div className="bg-dark-800 py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">See GhostHub in Action</h2>
          <p className="mt-6 text-lg leading-8 text-gray-300">
            Watch how easy it is to set up and use GhostHub for your media collection
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-4xl aspect-video overflow-hidden rounded-xl shadow-xl">
          <div className="relative pb-[56.25%] h-0 overflow-hidden max-w-full">
            <iframe 
              className="absolute top-0 left-0 w-full h-full" 
              src="https://www.youtube.com/embed/mmsr77dQQmw" 
              title="GhostHub Demo Video" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
